import { useEffect, useState } from "react";
import {
  firstOrUndefined,
  SiteAssignment,
  SiteAssignmentCompanyAssocEntity,
  SiteAssignmentEntity,
  TransportCategory,
  useLazyGetCompanySiteAssignmentBySiteQuery
} from "@ots-frontend/ots-data";

const sort = (a: SiteAssignmentCompanyAssocEntity, b: SiteAssignmentCompanyAssocEntity, service: boolean): number => {
  if (service) {
    return a.servicePreferenceRank - b.servicePreferenceRank;
  } else {
    return a.normalPreferenceRank - b.normalPreferenceRank;
  }
};

const getPreferredCompanyId = (payload: SiteAssignment | undefined, service: boolean): string | undefined => {
  const assignment = payload ? SiteAssignmentEntity.from(payload) : undefined;
  const sortedAssocs = assignment?.companyAssocs?.sort((a, b) => {
    return sort(a, b, service);
  });
  return firstOrUndefined(sortedAssocs)?.companyId;
};

export type UseGetPreferredCompanyProps = {
  serviceWork?: boolean;
  siteId?: string;
  regionId?: string;
  category?: TransportCategory
}

export type UseGetPreferredCompanyResult = {
  companyId?: string
}

export const useGetPreferredCompany = (props: UseGetPreferredCompanyProps): UseGetPreferredCompanyResult => {
  const { serviceWork = false, siteId, regionId, category } = props;

  const [_companyId, _setCompanyId] = useState<string | undefined>(undefined);

  const [trigger] = useLazyGetCompanySiteAssignmentBySiteQuery();

  useEffect(() => {
    if (regionId && siteId && category) {
      trigger({ regionId: regionId, siteId: siteId, category: category.code })
        .unwrap()
        .then((payload) => {
          const companyId = getPreferredCompanyId(payload, serviceWork);
          _setCompanyId(companyId);
        });
    } else {
      _setCompanyId(undefined);
    }
  }, [trigger, siteId, regionId, category, serviceWork]);

  return {
    companyId: _companyId
  };
};
